import { connect } from 'react-redux'
import { setParentFormField, setParentForm } from 'actions/account/parents'

const mapStateToProps = ({ parents: { form } }) => ({ form })

const actions = { setParentFormField, setParentForm }

const withRedux = connect(
  mapStateToProps,
  actions
)

export default withRedux
